import { useRef, useEffect } from 'react'
import classNames from 'classnames'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import styles from './EffectSection.module.scss'
import { useOnload } from '../../hooks/useOnload'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(ScrollTrigger)

export const EffectSection = (props) => {
  const effectRef = useRef(null)
  const onload = useOnload()

  useGSAP(() => {
    gsap.set(effectRef.current, {
      display: 'flex',
      autoAlpha: 0
    })

    ScrollTrigger.create({
      trigger: props.parent,
      start: 'top center',
      end: 'bottom center',
      onToggle: self => {
        if(self.isActive) {
          gsap.set(effectRef.current, {willChange: 'transform'})
        }
        gsap.to(effectRef.current, {
          autoAlpha: self.isActive ? 1 : 0,
          duration: 1,
          onComplete() {
            if(!self.isActive) gsap.set(effectRef.current, {willChange: 'auto'})
          }
        })
      }
    })
  }, [props.parent, onload])

  return props.parent ? (
    <div 
      className={classNames(
        styles['effect-section'],
        {
          [styles[`effect-section--${props.theme}`]]: props.theme
        }
      )}
      ref={effectRef}
    >
      {(props.quantity && props.quantity > 0) && Array(props.quantity).fill('').map((item, index) => (
        <div
          key={index + 1}
          className={classNames(
            styles['effect-section__item'],
            styles[`effect-section__item--${index + 1}`]
          )}
        />
      ))}
    </div>
  ) : null
}